/**
 * CMS — overzicht; actieve modules (reviews) hebben eigen routes.
 */
import { Link } from 'react-router-dom';
import { MessageSquareQuote, Newspaper } from 'lucide-react';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { SeoMeta } from '../../components/SeoMeta';

const SECTIONS = ['hero', 'features', 'faq', 'footer'] as const;

export function AdminCms() {
  return (
    <div>
      <SeoMeta
        path="/admin/cms"
        noindex
        title="CMS"
        description="Intern CMS voor configureerbare contentblokken in CalqTool™ — platformbeheer."
      />
      <Breadcrumbs items={[{ label: 'Platformbeheer', href: '/admin' }, { label: 'CMS' }]} />
      <h1 className="mb-4 text-2xl font-bold text-text">CMS</h1>
      <p className="mb-6 max-w-2xl text-text-muted">
        Configureerbare content voor de publieke site. Onderdelen zonder API verschijnen hier als gepland; actieve
        modules kun je direct openen.
      </p>

      <div className="mb-8 grid gap-4 sm:grid-cols-2">
        <Link
          to="/admin/cms/blog"
          className="flex max-w-md items-start gap-3 rounded-xl border border-border bg-surface-card p-4 shadow-sm transition hover:border-primary/40 hover:shadow-md"
        >
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <Newspaper className="h-5 w-5" aria-hidden />
          </span>
          <span>
            <span className="block font-semibold text-text">Blog</span>
            <span className="mt-1 block text-sm text-text-muted">
              Publieke pagina <code className="rounded bg-surface px-1 text-xs">/blog</code> — artikelen in D1; SEO,
              HTML-inhoud en publicatie per artikel bewerken.
            </span>
          </span>
        </Link>
        <Link
          to="/admin/cms/reviews"
          className="flex max-w-md items-start gap-3 rounded-xl border border-border bg-surface-card p-4 shadow-sm transition hover:border-primary/40 hover:shadow-md"
        >
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <MessageSquareQuote className="h-5 w-5" aria-hidden />
          </span>
          <span>
            <span className="block font-semibold text-text">Reviews</span>
            <span className="mt-1 block text-sm text-text-muted">
              Publieke pagina <code className="rounded bg-surface px-1 text-xs">/reviews</code> — citaten, namen en
              profielfoto-URL’s (KV).
            </span>
          </span>
        </Link>
      </div>

      <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-text-muted">Gepland (niveau 2)</h2>
      <div className="space-y-4">
        {SECTIONS.map((section) => (
          <div key={section} className="rounded-lg border border-border bg-surface-card p-4">
            <h3 className="mb-2 font-medium capitalize text-text">{section}</h3>
            <p className="text-sm text-text-muted">Blokken: titel, tekst, afbeelding, volgorde — API volgt.</p>
          </div>
        ))}
      </div>
    </div>
  );
}
